var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sellerCroact"},[_c('div',{staticClass:"manage-table"},[_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.data,"loading":_vm.loading,"pagination":false,"rowKey":function (record,index){return index}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }